import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { CreateNoteRequest } from "./CreateNoteRequest";
import { CreateNoteResponse } from "./CreateNoteResponse";
import { CreateNotesRequest } from "./CreateNotesRequest";
import { DeleteNoteRequest } from "./DeleteNoteRequest";
import { GetNotesByAssetsRequest } from "./GetNotesByAssetsRequest";
import { GetNotesByAssetsResponse } from "./GetNotesByAssetsResponse";
import { GetNotesBySubjectIdsRequest } from "./GetNotesBySubjectIdsRequest";
import { GetNotesBySubjectIdsResponse } from "./GetNotesBySubjectIdsResponse";
import { GetNotesRequest } from "./GetNotesRequest";
import { GetNotesResponse } from "./GetNotesResponse";

export const useNotesApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const masterApiUrl = appConfigContext.masterConfig.apiUrl;

    const { httpGet, httpPost, httpDelete } = useAuthorizedFetch();

    const getNotes = async (request: GetNotesRequest): Promise<GetNotesResponse> => {
        return httpGet<GetNotesResponse>(`${masterApiUrl}/notes`, request);
    };

    const getNotesBySubjectIds = async (
        request: GetNotesBySubjectIdsRequest
    ): Promise<GetNotesBySubjectIdsResponse> => {
        return httpPost<GetNotesBySubjectIdsResponse>(`${masterApiUrl}/notes/get-by-subject-ids`, request);
    };

    const getNotesByAssets = async (request: GetNotesByAssetsRequest): Promise<GetNotesByAssetsResponse> => {
        return httpPost<GetNotesByAssetsResponse>(`${masterApiUrl}/notes/get-by-assets`, request);
    };

    const createNote = async (request: CreateNoteRequest): Promise<CreateNoteResponse> => {
        return httpPost<CreateNoteResponse>(`${masterApiUrl}/notes/create-single`, request);
    };

    const createNotes = async (request: CreateNotesRequest): Promise<void> => {
        await httpPost(`${masterApiUrl}/notes/create-multiple`, request);
    };

    const deleteNote = async (request: DeleteNoteRequest): Promise<void> => {
        await httpDelete(`${masterApiUrl}/notes/delete`, request);
    };

    return {
        getNotes,
        createNote,
        createNotes,
        deleteNote,
        getNotesBySubjectIds,
        getNotesByAssets
    };
};
